import type { StoryPeriod } from './story-model';

export interface PeriodTrack {
  readonly period: StoryPeriod;
  readonly track: number;
}

export interface PeriodTrackLayout {
  readonly tracks: readonly PeriodTrack[];
  readonly trackCount: number;
}

export function buildPeriodTrackLayout(periods: readonly StoryPeriod[]): PeriodTrackLayout {
  const sorted = periods
    .slice()
    .sort(
      (left, right) => left.fromPosition - right.fromPosition || left.toPosition - right.toPosition,
    );
  const activeEnds: number[] = [];
  const tracks: PeriodTrack[] = [];

  for (const period of sorted) {
    const track = findAvailableTrack(activeEnds, period.fromPosition);
    activeEnds[track] = period.toPosition;
    tracks.push({ period, track });
  }

  return { tracks, trackCount: activeEnds.length };
}

function findAvailableTrack(activeEnds: readonly number[], startPosition: number): number {
  for (let index = 0; index < activeEnds.length; index += 1) {
    if (activeEnds[index] < startPosition) {
      return index;
    }
  }
  return activeEnds.length;
}
